import { useEffect, useState } from "react";
import { api, formatINR } from "@/lib/api";

export default function MallOwnerBookings() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/mall-owner/bookings").then((r) => setRows(r.data)).catch(() => setRows([])).finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="mall-owner-bookings">
      <div className="text-[11px] uppercase tracking-[0.3em] font-semibold text-[var(--gold)]">Bookings</div>
      <h1 className="mt-3 font-serif-display text-4xl text-[var(--ink)]">{rows.length} orders on your inventory</h1>

      {loading ? <div className="mt-8 text-[var(--slate-2)]">Loading…</div> : rows.length === 0 ? (
        <div className="mt-10 surface p-12 text-center">
          <div className="font-serif text-3xl">No bookings yet.</div>
          <p className="mt-2 text-[var(--slate-1)]">Advertiser orders against your inventory will appear here.</p>
        </div>
      ) : (
        <div className="mt-8 surface overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="border-b border-[var(--border)] text-left text-[10px] uppercase tracking-[0.22em] text-[var(--slate-2)]">
              <tr>
                <th className="p-4">Brand</th>
                <th className="p-4">Advertiser</th>
                <th className="p-4">Cities</th>
                <th className="p-4">Budget</th>
                <th className="p-4">Duration</th>
                <th className="p-4">Status</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((o) => (
                <tr key={o.id} className="border-b border-[var(--border)]">
                  <td className="p-4 font-medium text-[var(--ink)]">{o.brand}</td>
                  <td className="p-4 text-[var(--slate-1)]">
                    <div>{o.client_name}</div>
                    <div className="text-xs text-[var(--slate-2)]">{o.client_email}</div>
                  </td>
                  <td className="p-4 text-[var(--slate-1)]">{(o.cities || []).join(", ") || "—"}</td>
                  <td className="p-4 text-[var(--gold)] font-medium whitespace-nowrap">{formatINR(o.budget)}</td>
                  <td className="p-4 whitespace-nowrap">{o.duration_weeks}w</td>
                  <td className="p-4"><span className="chip">{o.status}</span></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
